/* eslint-disable */
import { Base64 } from 'js-base64';
import { AUTH_TYPES } from 'auth/state/service/authApi';
import { checkAuthentication, getToken } from '../../legacy/containers/Auth';
import { DATASOURCES, KARDIA_PRO_REGION } from '../../legacy/constants';
import { getDataSource } from '../../legacy/store/appReducer';
import store from '../appStore';

export const setRegion = region =>
  localStorage.setItem(KARDIA_PRO_REGION, region);

export const getRegion = () => {
  if (process.env.REACT_APP_ENABLE_API_REGION === '0') return '';
  let region = localStorage.getItem(KARDIA_PRO_REGION) || '';
  if (region.toLowerCase() !== 'us' && region.toLowerCase() !== 'eu' && region.toLowerCase() !== 'ap' && region.toLowerCase() !== 'cn') {
    region = 'us';
    setRegion(region);
  }
  return region;
};

export const getApiBaseUrl = () => {
  const isClinical = process.env.REACT_APP_IS_CLINICAL;
  let region = getRegion();
  if (region === 'cn') {
    // kardia-k8s.cn-production.kardiapro.cn
    return `${process.env.REACT_APP_API_PROTOCOL}://kardia-k8s.cn-production.kardiapro.cn/i/v1`
  }
  const goKardiaClinicalAPIV1 = `${process.env.REACT_APP_GOKARDIA_CLINICAL_API_DOMAIN}/i/v1`
  const goKardiaClinicalAPIURL =
  region === 'us'
    ? goKardiaClinicalAPIV1
    : goKardiaClinicalAPIV1.replace(
        'us',
        region,
      );
return isClinical
  ? `${process.env.REACT_APP_API_PROTOCOL}://${goKardiaClinicalAPIURL}`
  : `${process.env.REACT_APP_API_PROTOCOL}://${region}-${process.env.REACT_APP_API_DOMAIN}/i/v1`;
};

// api base url for V2
export const getApiBaseUrlv2 = () => {
  const isClinical = process.env.REACT_APP_IS_CLINICAL;

  let region = getRegion();
  if (region === 'cn') {
    // kardia-k8s.cn-production.kardiapro.cn
    return `${process.env.REACT_APP_API_PROTOCOL}://kardia-k8s.cn-production.kardiapro.cn/i/v2`;
  }
  const goKardiaClinicalAPIV2 = `${process.env.REACT_APP_GOKARDIA_CLINICAL_API_DOMAIN}/i/v2`;
  const goKardiaClinicalAPIURL =
    region === 'us'
      ? goKardiaClinicalAPIV2
      : goKardiaClinicalAPIV2.replace('us', region);
  return isClinical
    ? `${process.env.REACT_APP_API_PROTOCOL}://${goKardiaClinicalAPIURL}`
    : `${process.env.REACT_APP_API_PROTOCOL}://${region}-${process.env.REACT_APP_API_DOMAIN}/i/v2`;
};

export const getTeamsBaseUrl = () => {
  // not ideal with redux store here. base to be in localStorage
  const me = getDataSource(store.getState(), DATASOURCES.ME);
  const { teams } = me.data;
  return `${getApiBaseUrl()}/teams/${teams[0].id}`;
};

// eslint-disable-next-line no-unused-vars
class ApiServerError extends Error {
  constructor(message, url) {
    super();
    this.message = message;
    this.name = 'ApiServerError';
    this.url = url;
  }
}

export const fetchApi = ({
  url = '',
  method = 'GET',
  body,
  header = {},
  authType = AUTH_TYPES.NONE,
  credentials = {}, // required for basic auth
  jsonError = false,
}) => {
  const { browser } = store.getState().app;
  const headers = new Headers(
    Object.assign(
      {},
      {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      header,
    ),
  );

  const { BEARER, BASIC, NONE } = AUTH_TYPES;
  let basicToken;
  const { username = '', password = '' } = credentials;

  switch (authType) {
    case BASIC:
      basicToken = Base64.encode(`${username}:${password}`) || '';
      headers.append('Authorization', `Basic ${basicToken}`);
      break;
    case BEARER:
      headers.append('Authorization', `Bearer ${getToken() || ''}`);
      break;
    case NONE:
    default:
      break;
  }

  if (browser && browser.name === 'ie') {
    headers.append('pragma', 'no-cache');
    headers.append(
      'cache-control',
      'no-cache, no-store, must-revalidate, max-age=0',
    );
  }

  const init = {
    method,
    headers,
    mode: 'cors',
  };

  if (body) {
    init.body = body;
  }

  return fetch(url, init)
    .then(res => {
      if (res.status === 401) {
        store.dispatch(checkAuthentication());
        throw new Error('Unauthorized');
      } else if (jsonError) {
        return res;
      } else if (res.status === 500) {
        throw new Error(res.statusText);
      }

      return res;
    })
    .catch(err => {
      // eslint-disable-next-line no-console
      console.log(err);
      throw err;
    });
};



// WEBPACK FOOTER //
// ./src/state/services/apiService.js